function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Ride-Show-Copy-41",
  transform: "translate(-281.000000, -563.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M285.745,566.992 L282.321149,566.909629 L282.231502,566.914797 C281.800961,566.976422 281.641851,567.556358 282.025047,567.820938 L284.843,569.767 L283.70722,572.998134 L283.685334,573.079944 C283.606054,573.510901 284.11093,573.845144 284.482425,573.561353 L287.204,571.482 L289.926052,573.561353 L289.997095,573.607449 C290.38246,573.816021 290.856359,573.439143 290.701257,572.998134 L289.565,569.767 L292.38343,567.820938 L292.452919,567.764064 C292.765011,567.461142 292.552856,566.898441 292.087328,566.909629 L288.663,566.992 L287.683342,563.709946 C287.541244,563.233998 286.867232,563.233998 286.725135,563.709946 L285.745,566.992 Z",
  id: "Star"
})));

function SvgIconFavorite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["svgRef", "title", "titleId"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? React.createElement("title", {
    id: titleId
  }, "Star") : title ? React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconFavorite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-favorite.2fbd0fb8.svg";
export { ForwardRef as ReactComponent };